<template>
  <div class="body-wrap boxed-container">
    <Header />
    <main>
      <TopBanner/>
      <TypeMarquee/>
      <Features/>
      <Pricing/>
    </main>
    <Footer/>
  </div>
</template>

<script>
import Pricing from "../components/Homepage/Pricing.vue";
import TypeMarquee from "../components/Homepage/TypeMarquee.vue";
import Features from "../components/Homepage/Features.vue";
import Footer from "../components/GeneralViews/Footer.vue";
import TopBanner from "../components/Homepage/TopBanner.vue";
import Header from "@/components/Homepage/Header.vue";

export default {
  name: "home",
  components: {
    Header,
    TopBanner,
    Footer,
    Features,
    TypeMarquee,
    Pricing
  }
};
</script>
